import { Injectable } from "@angular/core";
import { IComment } from "projects/models/src/public-api";
import { Observable } from "rxjs";
import { NgCommentService, NgHttpService } from "../abstracts";

@Injectable()
export class CommentService implements NgCommentService {

  constructor(private http: NgHttpService) {}

  getCommentsCountByPostId(postId: number): Observable<number> {
    return this.http.get<number>('/wp-json/com-on/v1/comments-count/' + postId);
  }

  getCommentsByPostId(postId: number, page: number = 1, per_page: number = 10, parent: number = 0): Observable<IComment[]> {
    return this.http.get<IComment[]>('/wp-json/wp/v2/comments', undefined, { post: postId, page, per_page, parent });
  }

  createComment(postId: number, comment: IComment): Observable<void> {
    comment.post = postId;
    return this.http.post<void>('/wp-json/wp/v2/comments', undefined, undefined, comment);
  }

  updateComment(commentId: number, comment: IComment): Observable<void> {
    return this.http.post<void>('/wp-json/wp/v2/comments/' + commentId, undefined, undefined, comment);
  }

  deleteComment(commentId: number): Observable<void> {
    return this.http.delete<void>('/wp-json/wp/v2/comments/' + commentId);
  }

}
